import app from 'flarum/forum/app';
import IndexPage from "flarum/forum/components/IndexPage";
import Mithril from 'mithril';
import Stream from "flarum/common/utils/Stream";
import Button from "flarum/common/components/Button";
import ConfirmTabComponent from "../Component/ConfirmTabComponent";
import Watermark from "../warterMarkJS";

export default class ConfirmPTSiteCheckPage<CustomAttrs> extends IndexPage {
  private siteId: string = Stream("")
  private confirmId: string = Stream("")
  private data: object = {}
  private keyDown: boolean = false
  private confirmRemark: string = Stream("")
  private loading: boolean = true

  oncreate(vnode: Mithril.VnodeDOM<CustomAttrs, this>) {
    super.oncreate(vnode);
    app.setTitle(app.translator.trans('mattoid-pt-site-information.forum.title'))

    Watermark.set('');
    // this.noCopyFn()

    this.siteId = Stream(this.attrs.siteId)
    this.confirmId = Stream(this.attrs.confirmId)

    this.loadResults()
  }

  view() {
    return (
      <div class="container" id="pt-site-info-body">
        <div class="DiscussionPage-stream">
          <div class="PostStream">
            <div class="Post-body">
              {/*{ConfirmTabComponent.component({'siteId': this.attrs.siteId, 'page': 'check', 'confirmId': this.attrs.confirmId})}*/}

              {this.loading && (
                <div class="DiscussionList">
                  <div class="DiscussionList-loadMore">
                    <div aria-label="loading…" role="status" data-size="medium"
                         class="LoadingIndicator-container LoadingIndicator-container--block LoadingIndicator-container--medium">
                      <div aria-hidden="true" class="LoadingIndicator"></div>
                    </div>
                  </div>
                </div>
              )}

              {!this.loading && (
                <div class="Site-Body">
                  <div>
                    <div className="Site-Spacing">
                      <label
                        className="Body-Label">{app.translator.trans('mattoid-pt-site-information.forum.check.type')}</label>
                      <span
                        className={this.data.initType || this.data.status == 0 ? 'Body-content Body-content-300 red' : 'Body-content Body-content-300'}>{this.data.type === 1 ? '无考核' : this.data.type === 0 ? '有考核' : ''}</span>
                      <span
                        className={this.data.initType ? "delete margin-left-10" : ""}>{this.data.initType === 1 ? '无考核' : this.data.initType === 0 ? '有考核' : ''}</span>
                    </div>
                    <div className="Site-Spacing">
                      <label
                        className="Body-Label">{app.translator.trans('mattoid-pt-site-information.forum.check.upload')}</label>
                      <span
                        className={this.data.initUpload || this.data.status == 0 ? 'Body-content Body-content-300 red' : 'Body-content Body-content-300'}>{this.data.upload}</span>
                      <span
                        className={this.data.initUpload ? "delete margin-left-10" : ""}>{this.data.initUpload}</span>
                    </div>
                    <div className="Site-Spacing">
                      <label
                        className="Body-Label">{app.translator.trans('mattoid-pt-site-information.forum.check.download')}</label>
                      <span
                        className={this.data.initDownload || this.data.status == 0 ? 'Body-content Body-content-300 red' : 'Body-content Body-content-300'}>{this.data.download}</span>
                      <span
                        className={this.data.initDownload ? "delete margin-left-10" : ""}>{this.data.initDownload}</span>
                    </div>
                    <div className="Site-Spacing">
                      <label
                        className="Body-Label">{app.translator.trans('mattoid-pt-site-information.forum.check.sharing-rate')}</label>
                      <span
                        className={this.data.initSharingRate || this.data.status == 0 ? 'Body-content Body-content-300 red' : 'Body-content Body-content-300'}>{this.data.sharing_rate}</span>
                      <span
                        className={this.data.initSharingRate ? "delete margin-left-10" : ""}>{this.data.initSharingRate}</span>
                    </div>
                    <div className="Site-Spacing">
                      <label
                        className="Body-Label">{app.translator.trans('mattoid-pt-site-information.forum.check.magic')}</label>
                      <span
                        className={this.data.initMagic || this.data.status == 0 ? 'Body-content Body-content-300 red' : 'Body-content Body-content-300'}>{this.data.magic}</span>
                      <span className={this.data.initMagic ? "delete margin-left-10" : ""}>{this.data.initMagic}</span>
                    </div>
                    <div className="Site-Spacing">
                      <label
                        className="Body-Label">{app.translator.trans('mattoid-pt-site-information.forum.check.integral')}</label>
                      <span
                        className={this.data.initIntegral || this.data.status == 0 ? 'Body-content Body-content-300 red' : 'Body-content Body-content-300'}>{this.data.integral}</span>
                      <span
                        className={this.data.initIntegral ? "delete margin-left-10" : ""}>{this.data.initIntegral}</span>
                    </div>
                    <div className="Site-Spacing">
                      <label
                        className="Body-Label">{app.translator.trans('mattoid-pt-site-information.forum.check.seed-rate')}</label>
                      <span
                        className={this.data.initSeedRate || this.data.status == 0 ? 'Body-content Body-content-300 red' : 'Body-content Body-content-300'}>{this.data.seed_rate}</span>
                      <span
                        className={this.data.initSeedRate ? "delete margin-left-10" : ""}>{this.data.initSeedRate}</span>
                    </div>
                    <div className="Site-Spacing">
                      <label
                        className="Body-Label">{app.translator.trans('mattoid-pt-site-information.forum.check.seed-time')}</label>
                      <span
                        className={this.data.initSeedTime || this.data.status == 0 ? 'Body-content Body-content-300 red' : 'Body-content Body-content-300'}>{this.data.seed_time}</span>
                      <span
                        className={this.data.initSeedTime ? "delete margin-left-10" : ""}>{this.data.initSeedTime}</span>
                    </div>
                    <div className="Site-Spacing">
                      <label
                        className="Body-Label">{app.translator.trans('mattoid-pt-site-information.forum.check.other')}</label>
                      <span
                        className={this.data.initOther || this.data.status == 0 ? 'Body-content Body-content-300 red' : 'Body-content Body-content-300'}>{this.data.other}</span>
                      <span className={this.data.initOther ? "delete margin-left-10" : ""}>{this.data.initOther}</span>
                    </div>
                  </div>
                  <div className="center">
                    <div>
                    <textarea class="FormControl" bidi={this.confirmRemark}
                              style="background-color: #ffffff"></textarea>
                    </div>
                    <div>
                      <div className="inlineBlock margin-10">
                        {
                          Button.component({
                            type: 'submit',
                            className: 'Button Button--primary',
                            loading: this.loading,
                            onclick: () => {
                              this.confirm(1)
                            }
                          }, app.translator.trans('mattoid-pt-site-information.forum.confirm-pass'))
                        }
                      </div>
                      <div className="inlineBlock margin-10">
                        {
                          Button.component({
                            type: 'submit',
                            className: 'Button',
                            loading: this.loading,
                            onclick: () => {
                              this.confirm(2)
                            }
                          }, app.translator.trans('mattoid-pt-site-information.forum.confirm-refuse'))
                        }
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }


  noCopyFn() {
    // 禁止复制
    document.body.oncopy = function () {
      return false
    };
    document.body.oncontextmenu = function () {
      return false
    };
    document.body.onselectstart = document.body.ondrag = function () {
      return false;
    }
    document.onkeydown = function () {
      if ((event.ctrlKey == true || event.metaKey == true) && event.keyCode == 83) {
        event.preventDefault();
      }
      if ((event.ctrlKey == true || event.metaKey == true) && event.code == 83) {
        event.preventDefault();
      }
    }

    // 禁止打印
    var c = document.createElement("span");
    c.style.display = "none";
    c.style.postion = "absolute";
    c.style.background = "#000";
    var first = document.body.firstChild;
    var wraphtml = document.body.insertBefore(c, first);
    c.setAttribute('width', document.body.scrollWidth);
    c.setAttribute('height', document.body.scrollHeight);
    c.style.display = "block";
    var cssNode3 = document.createElement('style');
    cssNode3.type = 'text/css';
    cssNode3.media = 'print';
    cssNode3.innerHTML = 'body{display:none}';
    document.head.appendChild(cssNode3);

    // 禁止选中
    var cssNode2 = document.createElement('style');
    cssNode2.type = 'text/css';
    cssNode2.media = 'screen';
    cssNode2.innerHTML = 'div{-webkit-touch-callout: none;-webkit-user-select: none;-khtml-user-select: none;-moz-user-select: none;-ms-user-select: none;user-select: none;}';
    document.head.appendChild(cssNode2);

    // 模糊内容
    function toBlur() {
      // document.body.style.cssText="-webkit-filter: blur(5px);-moz-filter: blur(5px);-ms-filter: blur(5px);-o-filter: blur(5px);filter: blur(5px);"
      $("#pt-site-info-body").css('-webkit-filter', 'blur(5px)');
      $("#pt-site-info-body").css('-moz-filter', 'blur(5px)');
      $("#pt-site-info-body").css('-ms-filter', 'blur(5px)');
      $("#pt-site-info-body").css('-o-filter', 'blur(5px)');
      $("#pt-site-info-body").css('filter', 'blur(5px)');
    }

    // 解除模糊
    function toClear(keyDown) {
      if (keyDown) {
        return;
      }
      // document.body.style.cssText="-webkit-filter: blur(0px);-moz-filter: blur(0px);-ms-filter: blur(0px);-o-filter: blur(0px);filter: blur(0px);"
      $("#pt-site-info-body").css('-webkit-filter', 'blur(0px)');
      $("#pt-site-info-body").css('-moz-filter', 'blur(0px)');
      $("#pt-site-info-body").css('-ms-filter', 'blur(0px)');
      $("#pt-site-info-body").css('-o-filter', 'blur(0px)');
      $("#pt-site-info-body").css('filter', 'blur(0px)');
    }

    toBlur()

    document.addEventListener('keydown', (e) => {
      this.keyDown = true;
      toBlur()
    })

    document.addEventListener('keyup', (e) => {
      this.keyDown = false;
    })

    $("#pt-site-info-body").mouseover(() => {
      toClear(this.keyDown)
    })

    $("#pt-site-info-body").mouseout(() => {
      toBlur()
    })
  }

  confirm(status) {
    this.loading = true;

    const params = {
      'status': status,
      'confirmId': this.confirmId(),
      'confirmRemark': this.confirmRemark(),
      'type': 'check'
    };
    app.request({
      method: 'PUT',
      url: app.forum.attribute('apiUrl') + '/confirm/site/status/' + this.siteId(),
      body: params
    }).then(
      (res) => {
        this.loading = false;
        app.alerts.show({
          type: "success",
        }, app.translator.trans('mattoid-pt-site-information.forum.confirm-success'));
        m.redraw();
      },
      (result) => {
        this.loading = false;
        this.handleErrors(result);
      });
  }

  refresh() {
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/pt/site/refresh/outtime',
    })
  }

  loadResults() {
    this.loading = true;

    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/confirm/pt/site/check/' + this.siteId() + '/' + this.confirmId(),
    }).then(
      (res) => {
        this.loading = false;
        if (res.data && res.data.attributes) {
          this.data = res.data.attributes
        }
        m.redraw();
      },
      (result) => {
        this.loading = false;
        this.handleErrors(result);
      });
  }
}
